export default __webpack_public_path__ + "img/fBayjdtZ.09aa459a.svg";